import { SUPPORT_EMAIL } from 'Copy';
import { AppRoutePath } from 'Pages/routes';
import Link from 'next/link';

export const serviceProviderSelectListEmpty = () => (
  <div
    className="flex flex-col min-h-40 text-center"
  >
    <span className="heading p-4">No service providers found!</span>
    <span
      className="p-4 whitespace-break-spaces"
    >
      Sorry, we don&apos;t have service providers in your area.<br />
      We&apos;re working on adding providers to serve you shortly.
    </span>
    <span
      className="p-4"
    >
      Try adjusting your location, or browsing another category.
    </span>
    <div
      className="flex justify-center"
    >
      <div
        className="flex justify-evenly sm:basis-full md:basis-1/2"
      >
        <Link
          href={AppRoutePath.BROWSE_SERVICE_TYPES}
          className="btn-primary"
        >
          Browse Categories
        </Link>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:${SUPPORT_EMAIL}`}
          className="btn"
        >
          Contact Us
        </a>
      </div>
    </div>
  </div>
);

